import Vue from 'vue'
import store from '../store'

const http_client = async (url, data = {}, method = 'get', headers = {}, sendToken=true) => {
    const token = store.getters.getToken ? store.getters.getToken : localStorage.getItem('token')
    if (token && sendToken) headers.Authorization = 'Bearer ' + token

    let config = {
        method,
        url,
        headers
    }
    if (method === 'get') {
        config.params = data
    } else {
        config.data = data
    }
    try {
        return await Vue.prototype.axios(config);
    } catch (e) {
        if (e.response.status === 401) {
            if (window.location.pathname === '/login')
                throw e
            // router.push('/login').catch(e=>{})
        } else if (e.response.status === 500) {
            await store.dispatch('utils/setAlert', {
                type: 'warning',
                message: 'No se puede tener comunicación con el servidor por favor intente en un momento',
                show: true
            })
            setTimeout(() => {
                store.dispatch('utils/hideAlert')
            }, 4000)
            throw e
        } else if (e.response.status === 403) {
            await store.dispatch('utils/temporalAlert', {
                type: 'warning',
                show: true,
                message: e.response.data.message ? e.response.data.message : 'No tiene permiso de realizar la acción'
            })
            await store.dispatch('utils/hideLoader')
            throw e
        } else {
            throw e
        }
    }
}

Vue.prototype.http_client = http_client

export {
    http_client
}
